import React, { useEffect } from "react";
import { selectorHelper } from "../../../util";
import { connect } from 'react-redux';
import { 
  currentNodeState, 
  repositoryState, 
  mappedRepositoryState,
  combineStates, 
  activeTabState, 
  activeTabDispatcher, 
  orderCodeState, 
  combineDispatchers, 
  orderCodeDispatcher,
  popupDispatcher,
  configuratorDispatcher,
  messageDispatcher,
  complexSelectorState,
  complexSelectorDispatcher,
  siteSettingsState,
  showFooterDispatcher,
  nodeState,
  showConfigureState,
  filterSelectorState,
  mobilePageViewDispatcher,
  mobilePageViewState,
  currentPageDispatcher,
  currentPageState,
  screenSizeState,
  productState
} from '../../../store';
import { ModelConfiguratorSelectorView } from "./productViewer/ModelConfiguratorSelectorView";
import { BusyContainer } from "../../../components";
import { ConfigureByCode, ResetButton } from "./productViewer";

// const shouldComponentUpdate = (prevProps, nextProps) =>{
//   return prevProps.activeTab.selector !== nextProps.activeTab.selector ||
//            prevProps.currentNode !== nextProps.currentNode ||
//            prevProps.currentSelector !== nextProps.currentSelector ||
//            prevProps.items !== nextProps.items ||
//            prevProps.complexSelectors !== nextProps.complexSelectors||
//            prevProps.screenSize.width !== nextProps.screenSize.width ||
//            prevProps.screenSize.height !== nextProps.screenSize.height
// }
const ModelConfiguratorSelectorComponent = (props)=>{
    const {currentNode, items, complexSelectors, siteSettings} = props;
    const name = currentNode.selectorName;
    const selectorName = selectorHelper.getSelectorName( currentNode.selectorName );
    const targetSelector = complexSelectors[name] || { selector: items.firstOrDefault( selector => selector.name === selectorName ) };
    const actions = ['filter-active'];
    // const headerTab = (this.state.showResetHeader)&&this.getResetHeader( currentNode, targetSelector );
    useEffect(()=>{
        if(props.currentPage.currentPage!=="modelConfiguratorSelectorPage"){
            props.setPage("modelConfiguratorSelectorPage")
          }
          props.hideFooter();
    },[])


    const configureByCode = ( value )=> {
        const { currentNode } = props;
        if ( !value ) {
        return;
        }
        const trimmedValue = value.trim();
        props.find( trimmedValue, currentNode.customProperties.modelToLoad ).then( product => {
        // no matching code was found
        if ( product === null ) {
            return props.addMessage( { 
            messageText: translate( 'No matching product found for "{code}"', { code: trimmedValue } ), 
            messageType: 'warning',
            timeout: 30000 
            } );
        }
        // a code was found, but the product is not available in the database
        if ( product.id === 0 ) {
            return props.addMessage( { 
            messageText: translate( 'The product with "{code}" is not available in your country', product ), 
            messageType: 'warning',
            timeout: 30000 
            } );
        }
        return props.retrieve( trimmedValue, currentNode.customProperties.modelToLoad ).then( defaultConfiguration => {
            const targetProduct = { 
            ...product, 
            materialName: currentNode.customProperties.modelToLoad, 
            configuration: { 
                sourceLocation: defaultConfiguration.configuration,
                plant: defaultConfiguration.plant,
                usage: defaultConfiguration.usage,
                materialKey: product.name,
                assignments: defaultConfiguration.existingAssignments.select() 
            } };
            props.setPopup( {
            title: translate( 'Configure {code}', { code: targetProduct.code || targetProduct.name } ),
            onClose: () => this.clearConfiguration( targetProduct.name ),
            component: <ConfiguratorPage 
                modelToLoad={ currentNode.customProperties.modelToLoad } 
                properties={ { ...currentNode.customProperties, settings: props.codeSettings.firstOrDefault( cs => cs.modelName === currentNode.customProperties.modelToLoad ) } }
                product={ targetProduct } isPopup 
            />,
            showHeader: true,
            keepOpen: true,
            } );
        } );
        } );
    }
    
    const updateComplexSelector = ( targetSelectorName, currentSelector ) => {
        props.setComplexSelector( { parentSelector: currentSelector.name, targetSelector: targetSelectorName } );
      }

    const getCurrentSelector = ( targetSelector ) => {
        const { activeTab, items } = props;
    
        switch( activeTab.selector ) {
          case 'Products':
            return targetSelector.selector;
          case 'Fixed Parts':
            const fixedPartsName = selectorHelper.getFixedPartsName( targetSelector?.selector?.name );
            return items.firstOrDefault( selector => selector.name === fixedPartsName );
          case 'Accessories':
            const accessoriesName = selectorHelper.getAccessoriesName( targetSelector?.selector?.name );
            return items.firstOrDefault( selector => selector.name === accessoriesName );
          case 'Loose Accessories':
            const looseaccessoriesName = selectorHelper.getAccessoriesName( targetSelector?.selector?.name );
            return items.firstOrDefault( selector => selector.name === looseaccessoriesName );
          default:
            return null;
        }
      }

    const getResetHeader = ( currentNode, targetSelector ) => {
        const elements = [], currentSelector = getCurrentSelector( targetSelector );
        if ( currentNode.customProperties && currentNode.customProperties.orderCodeAvailable ) {
          elements.push(
            { 
              customHeader: <ConfigureByCode configure={ this.configureByCode } currentSelector={ currentSelector } />,
              isDisabled: false
            }
          );
        }
        elements.push( {
          title:"Reset Buttons",
          customHeader: <ResetButton currentSelector={ currentSelector } />,
          isDisabled: false
        } );
        return elements;
      }

    const headerTab = getResetHeader( currentNode, targetSelector );
    
    return <BusyContainer isRequired actions={ actions }> 
   {!items.none( sel => sel.name === selectorName ) && <ModelConfiguratorSelectorView 
        onConfigureRequest={ configureByCode } 
        parentSelector={ items.firstOrDefault( selector => selector.name === selectorName ) } 
        onSelectorChanged={ updateComplexSelector } 
        currentSelector={ targetSelector }
        resetHeader={headerTab}
        // showResetHeader = {this.state.showResetHeader}
        // setShowResetHeader = {this.setShowResetHeader}
        screenSize = {props.screenSize}
        siteSettings = {siteSettings}
        currentNode = {props.currentNode}
  />}</BusyContainer>
};

export const ModelConfiguratorSelectorPage =  connect( 
    combineStates( currentNodeState, nodeState,showConfigureState, activeTabState, siteSettingsState,mobilePageViewState, complexSelectorState, repositoryState( 'selector' ), mappedRepositoryState( 'codeSettings', 'codeSettings' ), orderCodeState, currentPageState, screenSizeState, productState ), 
    combineDispatchers( orderCodeDispatcher, complexSelectorDispatcher, popupDispatcher, configuratorDispatcher, messageDispatcher, activeTabDispatcher, showFooterDispatcher, mobilePageViewDispatcher, currentPageDispatcher )
  )( ModelConfiguratorSelectorComponent );